import { useApolloClient, useGetOffersBySearchQuery, useGetStaComposerMemberFields } from '@frontend/applications/AffiliatesApp/hooks';
import { useClientFeatures } from '@frontend/context/ClientFeatureContext';
import { SEND_STA_TASK_ID } from '@frontend/applications/AffiliatesApp/types/globalTypes';
import { useMemo } from 'react';
import initialEmailState from '@frontend/applications/AffiliatesApp/containers/STASendItems/initialEmailState';

interface IProps {
  taskId: SEND_STA_TASK_ID;
  programId: number;
}
export const useGetOfferEmailBody = (props: IProps) => {
  const { taskId, programId } = props;

  const defaultEmailSubject = useMemo(() => {
    let subject = 'Here is your sales tracking ';
    switch (taskId) {
      case SEND_STA_TASK_ID.send_link_and_promo_task:
        subject += 'promo code and link';
        break;
      case SEND_STA_TASK_ID.send_link_task:
        subject += 'link';
        break;
      case SEND_STA_TASK_ID.send_promo_task:
        subject += 'promo code';
        break;
      default:
        break;
    }

    return subject;
  }, [taskId]);

  const staApolloClient = useApolloClient();

  const { data: offers } = useGetOffersBySearchQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      query: { programId },
    },
    client: staApolloClient,
  });

  const staMemberFieldIds = useGetStaComposerMemberFields();

  const { migrateToGraphQL, MemberPortal: memberPortalFeatureFlagEnabled } = useClientFeatures();

  const { blocks, entityMap } = useMemo(() => {
    if (!offers?.offers) {
      return {
        blocks: [],
        entityMap: {},
      };
    }
    return initialEmailState(taskId, offers?.offers, staMemberFieldIds, memberPortalFeatureFlagEnabled, migrateToGraphQL);
  }, [taskId, offers, staMemberFieldIds, memberPortalFeatureFlagEnabled, migrateToGraphQL]);

  return {
    subject: defaultEmailSubject,
    blocks,
    entityMap,
  };
};
